import React from 'react'
import './DownloadUniwallet.scss'
import phone from '../../assets/phone.png'
import { Link } from 'react-router-dom'
import googleplay from '../../assets/googleplay.png'
import appleStore from '../../assets/applestore.png'
import Lottie from 'lottie-react'
import mobile from '../../assets/animation/Mobile.json'
function DownloadUniwallet() {
	return (
		<div className='uniPayData'>
			<div className='downloaduni container'>
				<div className='downloaduni_left'>
					<h4>Shape Your Financial Legacy
					</h4>
					<h2>
						Download UniWallet <span>Pay</span></h2>
					<div className='downloaduni_left_buttons'>
						<Link to=''><img src={googleplay} alt='imgs' /></Link>
						<Link to=''><img src={appleStore} alt='imgs' /></Link>
					</div>
				</div>
				<div className='downloaduni_right'>
					{/* <img src={phone} alt='imgs' /> */}
					<Lottie
						animationData={mobile}
						loop
						autoPlay
						className="uni-lottie"
					/>
				</div>
			</div>
		</div>
	)
}

export default DownloadUniwallet